import * as React from 'react';
import './circleDisplay.scss';

interface CircleDisplayProps {
    heading?: string;
    className?: string;
    large?: boolean;
    small?: boolean;
    circleIcon?: string;
}

const circleDisplay = (props: CircleDisplayProps): JSX.Element => {
    const { heading, className, large: largeVal, circleIcon, small: smallVal } =  props;
    const largeClass = largeVal ? 'large' : '';
    const smallClass = smallVal ? 'small' : '';
    const classStr = `circle-display ${className || ''} ${largeClass} ${smallClass}`;

    if (largeVal) {
        return (
            <div className={classStr.trim()}>
                <h2 className="circle-display-inner">
                    {!circleIcon && heading}
                    {circleIcon && <i className={`${circleIcon}`} />}
                </h2>
            </div>
        );
    }

    return (
        <div className={classStr.trim()}>
            <h5 className="circle-display-inner">
                {!circleIcon && heading}
                {circleIcon && <i className={`${circleIcon}`} />}
            </h5>
        </div>
    );
};

export { circleDisplay as CircleDisplay };
export default circleDisplay;